// extracted by mini-css-extract-plugin
export default {"contentCard":"contentCard_contentCard__o1DWI"};